import React from "react";
import { Box } from "@mui/material";
import Navbar from "components/Navbar/index";
import FeaturesHeroSection from "components/FeaturesHeroSection/index";
import EverythingYouNeedSection from "components/EverythingYouNeedSection/index";
import WhyFitifyIsBetterSection from "components/WhyFitifyIsBetterSection/index";
import HowFitifyWorksSection from "components/HowFitifyWorksSection/index";
import DashboardProgressSection from "components/DashboardProgressSection/index";
import FooterSection from "components/FooterSection/index";

const FeaturesPage = () => {
  return (
    <Box
      sx={{
        minHeight: "auto",
        backgroundColor: "#1A1A1A",
        color: "#FFFFFF",
        position: "relative",
        overflow: "hidden",
        fontFamily: "Outfit",
      }}
    >
      {/* Navigation */}
      <Box sx={{ position: "relative", zIndex: 3 }}>
        <Navbar />
      </Box>

      {/* Features Hero Section */}
      <FeaturesHeroSection />

      {/* Everything You Need Section */}
      <EverythingYouNeedSection />

      {/* Why Fitify is Better Section */}
      <WhyFitifyIsBetterSection />

      {/* How Fitify Works Section */}
      <HowFitifyWorksSection />

      {/* Dashboard Progress Section */}
      <DashboardProgressSection />

      {/* Footer Section */}
      <FooterSection />
    </Box>
  );
};

export default FeaturesPage;
